export const environment = {
  firebase: {
    apiKey: "AIzaSyBumE23YxrG9EkwL-hIBMfElb-XXButNEA",
    authDomain: "staging.fll.nexus",
    databaseUrl: "https://nexus-fll-staging-default-rtdb.firebaseio.com",
    projectId: "nexus-fll-staging",
    storageBucket: "nexus-fll-staging.firebasestorage.app",
    messagingSenderId: "189747597824",
    appId: "1:189747597824:web:ad631a68b30d441c02bee5",
    measurementId: "G-R9W08YN35S"
  },
  production: true,
  useEmulatedFunctions: false,
  emulatedRubricUrl: false,
  emulatedScoresheetsUrl: false,
  emulatedAwardsUrl: false,
  hostUrl: 'https://staging.fll.nexus',
  shortUrl: 'fll.nexus',
  googleMapsApiKey: 'AIzaSyDw4DREEBhIF0aY9-S_ehYp0xPIK89Szf8',
};
